import { AttachmentService, FindWorkComCommand, MediaReference, PermissionAccess, PermissionVisibility, PopUtils, StaticFeatureEnum, StyleVO, UserServiceCmd, WorkcomCall } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { CONFIRMATION_MODE, CONFIRMATION_RESULT, WizMathUtils, WIZ_EVENT_TYPE, WIZ_UPLOAD_ACCEPT_FORMAT, VALUE_ENTER, CODE_SPACE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  WizDatasource,

  WizGroupCommand,
  WizPopUp,
  WizRoot,
  WizTextInput,
  WizValidationContainerDirective,

  WizVgroup,
  WizIcon,
  WizEventManager, WizEvent,
  WizTextarea,
  WizAgGrid,
  UploadParameter,
  WizGroup,
  WizHgroup,
  WizImage,
  ImageUploadParameter,
  WizDropdown,
  WizDateField,
} from '@wizeoo/akm-component-lib';
import { MultiDisplay, MultiDisplayConfig, zoomPopParams } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { WorkComVO } from '@wizeoo/akm-compute-lib';
import { UserVO } from '@wizeoo/akm-common-lib';
import { Observable, of } from 'rxjs';
import { Attachment, DataPack } from '@wizeoo/akm-message-lib';
import { FakeVO } from '@wizeoo/akm-common-lib';


/**
 * Vue de gestion des rendus CSS
 * Author LMA
 */
@Component({
  selector: 'workflow-view',
  templateUrl: './workflow.view.html',
})
export class WorkflowView extends BaseView {
  @ViewChild('mdMain') mdMain: MultiDisplay<WorkComVO>; // grid principal

  @ViewChild('tiObj', { read: WizTextInput }) tiObj: WizTextInput; // champ de saisie du code
  @ViewChild('taContent', { read: WizTextarea }) taContent: WizTextarea; // champ de saisie de la regexp
  @ViewChild('taParams', { read: WizTextarea }) taParams: WizTextarea; // champ de saisie de la regexp
  @ViewChild('ddState', { read: WizDropdown }) ddState: WizDropdown;
  @ViewChild('da', { read: WizDateField }) public da: WizDateField;
 

  @ViewChild('vgEdition', { read: WizVgroup }) vgEdition: WizVgroup; // ensemble de la zone de détail pour écoute ModelUpdate
  @ViewChild('vgEdition', { read: WizValidationContainerDirective, static: false })
  private vgEditionCheck: WizValidationContainerDirective; // Zone de validation globale

  /** Bouton d'ajout */
  @ViewChild('btnCreate', { read: WizIcon }) btnCreate: WizIcon;
  /** Bouton d'export */
  @ViewChild('btnExport', { read: WizIcon, static: false }) btnExport: WizIcon;
  /** Bouton d'import */
  @ViewChild('btnImport', { read: WizIcon, static: false }) btnImport: WizIcon;
  /** Bouton de suppression */
  @ViewChild('btnRemove', { read: WizIcon, static: false }) btnDelete: WizIcon;

  public currentWorkcom: WorkComVO = null; // sélection active (objet métier vrai)
  public clone: WorkComVO = null; // clone de travail



  /** Constructeur */
  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef) {
    super(elementRef);
  }

  /** DS du grid principal */
  public mainDS: WizDatasource<WorkComVO> = new WizDatasource<WorkComVO>([])
    .setSortFields([{ property: 'obj', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop de types de données */
  public stateDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().workflowState)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .build();



  /** Configuration du mode multi display (principal) */
  public mainConfig: MultiDisplayConfig<WorkComVO> = {
    model: Model.getInstance(),
    datasource: this.mainDS,
    defaultMode: 'grid',
    onSelectionChanging: this.askSelectMain.bind(this),
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.common.code.$', width: 80, sortable: true, field: 'obj', tooltipField: 'obj' },
        { headerName: '$.common.code.$', width: 140, sortable: true, field: 'naturalUID', tooltipField: 'naturalUID' },
        { headerName: '$.datatype.comment.$',flex:1, minWidth: 100, sortable: true, field: 'comment', tooltipField: 'comment' },

      ],
    },
    filter: {
      enabled: true,
      initFilter: this.initMainFilter.bind(this),
    },
  };

  /* #############################################################
                      CYCLE DE VIE
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const commands = [];
    // chargement des messages
    // if (!Model.getInstance().workcomList) {
    //   commands.push(new FindWorkComCommand(Model.getInstance()));
    // }

    // chargement des messages
    if (!Model.getInstance().workflowEngine.getWorkcomMap()) {
      commands.push(new WorkcomCall(Model.getInstance()));
    }

    // chargement des users
    if(!Model.getInstance().usersMap) {
      // Chargement des users dans tous les cas
      commands.push(new UserServiceCmd(Model.getInstance()).find());

    }

    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands, null, false);
    } else {
      return null;
    }
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {

    super.managePermissions([
      {
        feature: StaticFeatureEnum.WORKFLOW,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnDelete,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    this.mainFilter.configure(['obj', 'comment'], null, null); // alimentation du filtre principal
    this.mainDS.setSource(Model.getInstance().workcomList); // alimentation de la liste principale
    
    this.usersFilter.configure(['mail', 'firstname', 'lastname'], null, null); 
    this.usersDS.setSource([...Model.getInstance().usersMap?.values() || []]); 

    this.ddState.wizDataProvider = this.stateDS; // alimentation de la drop des types de données

    this.feed();
  }

  private reset(): void {
    this.tiObj.wizValue = null; // alimentation du code
    this.taContent.wizValue = null; // alimentation du format
    this.stateDS.clearSelection();
    this.imgSrcObs = of(null);
    this.img.sourceObservable = of(null);
    this.mediaReference = null;
    this.da.wizNumberValue = null;
    this.usersDS.clearSelection();
    ViewData.wizUpdateModel = false;
  }

  /** alimentation de la zone de détail */
  private feed(): void {
    // TODO ici gestion des permissions

    

 
    this.vgEdition.visible = !!this.clone;

    if (!!this.clone) {
      this.reset();
      
      this.tiObj.wizValue = this.clone.obj; // alimentation du code
      this.taContent.wizValue = this.clone.comment; // alimentation du format

      this.taParams.wizValue = JSON.stringify(this.clone.params);

      if(this.clone.params) {
        let params: any = this.clone.params;

        if(params.img) {
          this.imgBlob = params.img;
          this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(this.imgBlob);
          this.img.sourceObservable = this.imgSrcObs;
        } else {
          this.imgBlob = null;
          this.imgSrcObs = of(null);

        }

        if(params.media) {
          this.mediaReference = params.media; // JSON.parse(params.media);  
          // this.mediaBlob = (params.media as Attachment).blobId;
          // this.mediaReference = AttachmentService.getInstance().downloadAttachmentForWidget(this.mediaBlob);
          // this.img.sourceObservable = this.imgSrcObs;
        } else {
          //this.mediaBlob = null;
          this.mediaReference = null;
        }

        if(params.targetDate) {
          this.da.wizNumberValue = params.targetDate;
        }

        let stateVO: FakeVO = null;
        if(params.state) {
          stateVO = this.stateDS.getItemByKey(params.state);
        }
        this.stateDS.select([stateVO]);


        if(params.to) {
          let toArr: string[] = params.to;
          let selectedUsers: UserVO[] = [];
          let us: UserVO;
          toArr.forEach(s => {
            us = this.usersDS.getItemByKey(s);
            if(!!us) {
              selectedUsers.push(us);
            }
          });

          this.usersDS.select(selectedUsers);

        }

      }


      if (this.clone.exist) {
        this.tiObj.wizDisabled = true;
      } else {
        this.tiObj.wizDisabled = false;
        setTimeout(() => {
          // sinon, pas le temps de rendre les compos enabled
          this.tiObj.wizFocus();
          this.cdref.markForCheck();
        }, 0);
      }
    }
  }

  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    super.wizAddListener();
    WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel); // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);

    WizEventManager.addListener(this, this.usersFilter, WIZ_EVENT_TYPE.FILTER, this.refreshUsersFilter);
    WizEventManager.addListener(this,this.usersGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.selectUsers); 


  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);

    WizEventManager.removeListener(this, this.usersFilter, WIZ_EVENT_TYPE.FILTER); 
    WizEventManager.removeListener(this,this.usersGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED);


  }

  /** fonction de suppression du format */
  public mayDelete(): boolean {
    return !this.cantDelete || !!this.currentWorkcom;
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableButtons(): boolean {
    return !ViewData.wizUpdateModel;
  }

  /* #############################################################
                  gestion sélection et filtres
     ############################################################# */

  private mainFilter: FilterComponent; // filterCompo du mdMain
  /** init du filter du mdMain */
  private initMainFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /** demande de changement de sélection */
  private askSelectMain(e: WizEvent = null): void {
    const vo: WorkComVO = e.value;
    if (ViewData.wizUpdateModel) {

      e.preventDefault(); // sélection pas self && modifs en cours

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelect.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        vo,
        null,
        null
      ).show();
    } else {
      if (!this.mainDS.isSelected(vo)) {
        // pas encore sélectionné
        this.doSelect(vo);
      } else {
        // déjà sélectionné, déselection
        this.doSelect(null);
      }
    }
  }

  /**
   * Confirmation de la sélection du CssRenderVO
   */
  private confirmSelect(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const vo: WorkComVO = result.data;
      this.mainDS.toggle(vo); // on a prevent l'event, on joue l'action
      this.doSelect(vo);
    }
  }

  /**
   * Changement de CssRenderVO sélectionné
   * @param pEvent WizEvent
   */
  private doSelect(vo: WorkComVO) {
    ViewData.wizUpdateModel = false;
    if (vo) {
      this.currentWorkcom = vo;
      this.clone = Model.getInstance().workflowEngine.clone(this.currentWorkcom);
    } else {
      this.currentWorkcom = null;
      this.clone = null;
    }
    this.feed();
  }

  /**
   * Changement de FormatVO sélectionné
   * @param pEvent WizEvent
   */
  public doCancel() {
    ViewData.wizUpdateModel = false;
    this.clone = Model.getInstance().workflowEngine.clone(this.currentWorkcom);
    this.feed();
  }

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.WORKFLOW);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.WORKFLOW);
        break;
    }
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    // Juste besoin de rafraichir les données spécifiques au domain/bu courant
    // TODO TODO refresh ciblé
    if (e && e.data === BATCH_KIND.WORKFLOW) {
      new FindWorkComCommand(Model.getInstance()).execute();
    }
  }

  private backFromReload(e: any): void {
    this.wizSynchronizeData();
  }

  /** création nouveau style */
  public askForAdd(): void {
    this.currentWorkcom = Model.getInstance().workflowEngine.buildFake();
    this.clone = Model.getInstance().workflowEngine.clone(this.currentWorkcom);
    this.mainDS.clearSelection();
    this.feed();
  }

  /** demande de suppression */
  public askForDelete(): void {
    WizPopUp.confirm(
      '$.common.delete.title.$',
      '$.common.delete.detail.$',
      this.doRemove.bind(this),
      CONFIRMATION_MODE.CONFIRM_CANCEL,
      this.currentWorkcom
    ).show();
  }

  /**
   * Suppression
   * @param result Objet de retour sur popUp de confirmation. Contient l'action choisie, et la data d'origine
   */
  private doRemove(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      Model.getInstance().workflowEngine.remove(this.clone, this.backFromMerge.bind(this));
    }
  }

  private ensureParams(who: WorkComVO): void {
    if(!who) {
      console.log('got you');
    } else {
      if(!who.params) {
        who.params = {};
      }
    }
  }

  /**
   * modification d'un élément de modèle
   * @param e WizEvent
   */
  private updateModel(e: WizEvent): void {
    switch (e.component) {
      case this.tiObj:
        const text: string = this.tiObj.wizValue;
        this.clone.obj = text;
        break;
      case this.taContent:
        this.clone.comment = this.taContent.wizValue;   
        break;
      case this.da:
        this.ensureParams(this.clone);
        this.clone.params.startDate = this.da.wizNumberValue;   
        break;   
      // case this.ddState:
      //   this.ensureParams(this.clone);
      //   this.clone.params.state = this.ddState.selectedItem?.code || null;   
      //   break;           
        
      case this.icoAddFile: 
        if(e.value) {
          let med: Attachment = e.value[0];
          let blobId: string = e.value[1];
          // this.mediaBlob = blobId;
          this.mediaReference = {fileName: med.fileName, fileType: med.fileType, blobId: blobId, shortFileName: med.fileName.substring(0,50), v2: false, directory: null};
          // this.mediaBlob = JSON.stringify(this.mediaReference);
        }
        // console.log('icoAddFile', valueStr);
      break;
      case this.icoDelFile: 
        // console.log('icoDelFile', e.component, e.value);
        // valueStr = e.value;
        this.mediaReference = null;
        //this.mediaBlob = null;
      break;
      case this.img:
        this.imgBlob = e.value;
        this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(e.value);
        this.img.sourceObservable = this.imgSrcObs;
        this.cdref.markForCheck();
      break;


    }
    // this.clone.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }


  /** persistence sur save */
  public doMerge(): void {

    this.ensureParams(this.clone);
    let params: any = this.clone.params;
    params.from = this.model.connectedUser.mail;
    params.to = [];
    if(this.usersDS.selectedItems?.length > 0) {
      this.usersDS.selectedItems.forEach(uvo => {
        params.to.push(uvo.mail);
      });
    }

    params.state = this.ddState.selectedItem?.code || null;   

    if(this.imgBlob) {
      params.img = this.imgBlob;
    }
    if(this.mediaReference) {
      params.media = this.mediaReference;
    }
    this.clone.params = params;


    const errors = this.vgEditionCheck.check(true, true);
    if (!errors || (!!errors && errors.length === 0)) {
      Model.getInstance().workflowEngine.merge(this.clone, this.currentWorkcom, this.backFromMerge.bind(this));
    } else {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Callback sur retour de persistence
   * @param datapack: DataPack
   */
  private backFromMerge(datapack: DataPack): void {

    this.mainDS.refresh();
    this.mainDS.clearSelection();
    this.currentWorkcom = null;
    this.clone = null;
    this.feed();
  }

  /**
   * Est-ce que l'utilisateur peut créer ?
   * @returns 
   */
  public get cantCreate(): boolean {
    return !Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.WORKFLOW);
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantUpdate(): boolean {
    return !Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.WORKFLOW);
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantDelete(): boolean {
    return !Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.WORKFLOW);
  }

  /* #############################################################
            users cibles pour les messages
     ############################################################# */

  @ViewChild('usersGrid') public usersGrid: WizAgGrid<UserVO>;
  @ViewChild('usersFilter', { read: FilterComponent, static: false }) usersFilter: FilterComponent;



  /** DS users */
  public usersDS: WizDatasource<UserVO> = new WizDatasource<UserVO>([])
    .setItemCodeField('mail')
    .setSortFields([{ property: 'mail', way: 'asc', numeric: false }])
    .setSelectionMode('multiple')
    .setFilter(this.usersFilterFunc.bind(this))
    .build();

  /**
   * Fonction de filtre des users
   * @param item Elément de la liste testé
   */
  private usersFilterFunc(item: UserVO): boolean {
    return this.usersFilter.checkVisible(item);
  }

  /**
   * Refresh du filtre users
   * @param event : Evenement de changement dans la zone de filtre
   */
  private refreshUsersFilter(event: WizEvent = null): void {
    this.usersDS.refresh();
  }

  public usersColumns = [
        { headerName: '$.user.firstname.$', width: 100, sortable: true, resizable: true, field: 'firstname', tooltipField: 'firstname' },
        { headerName: '$.user.lastname.$', width: 100, sortable: true, resizable: true, field: 'lastname', tooltipField: 'lastname' },
        { headerName: '$.user.mail.$', minWidth: 140, flex: 1, sortable: true, resizable: true, field: 'mail', tooltipField: 'mail' },
       ];

  private selectUsers(e:WizEvent): void {
    // console.log('select users', e);
  }

  /* ##############################################################################
          pièces jointes
  ############################################################################## */

  @ViewChild('dropGrp', { read: WizGroup, static: false }) dropGrp: WizGroup; // zone de drop de fichier
  @ViewChild('icoAddFile', { read: WizIcon, static: false }) icoAddFile: WizIcon; // ajout de fichier
  @ViewChild('icoDelFile', { read: WizIcon, static: false }) icoDelFile: WizIcon; // suppression du lien de fichier


  public imgSrcObs: Observable<string> = of(null);
  public mediaReference: MediaReference = null;

  public imgBlob: string = null;
  // public mediaBlob: string = null;

  /** on utilise le lien vers un fichier, et il existe */
  public get dropFull():boolean {
    // console.log('dropFull', this.datakind, this. formatedValue);
    return !!this.mediaReference;
  }
  
 /**
   * neutralisation du dragOver, sinon le drop ne fonctionne pas...sous chrone
   */
  public dover(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    // console.log('dover', evt);
  }

  /**
     * Demande de chargement d'un fichier
     */
  public selectFile(): void {

    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      elementRef: this.dropGrp.elementRef,
      targetPath: null,
      viewCallback: this.backFromSelect.bind(this)
    }
    this.model.batchEngine.loadFile(params);
  }

  /**
   * retour de sélection de fichier
   * @param params 
   */
  private backFromSelect(params: UploadParameter): void {
    if(params.files?.length > 0) {
      params.viewCallback = this.backFromDrop.bind(this);
      this.model.batchEngine.dropFile(params);
    }
  } 

  /**
   * Demande de chargement par drop
   */
  public dropFile(evt: DragEvent): void {
    
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const files = evt.dataTransfer.files;
    let file: File = files[0];
  
    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      elementRef: this.dropGrp.elementRef,
      targetPath: null,
      files: [file],
      viewCallback: this.backFromDrop.bind(this)
    }
    
    this.model.batchEngine.dropFile(params);
  }

  /**
   * retour de chargement, enregistrement
   * @param media 
   * @param blobId 
   */
  private backFromDrop(media: Attachment, blobId: string): void {  
    WizEventManager.dispatchEvent(this.icoAddFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoAddFile, [media, blobId]));
    this.cdref.markForCheck();
  }

  /**
   * suppression de la pièce jointe
   */
  public clearDropFile(): void {
    WizEventManager.dispatchEvent(this.icoDelFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoDelFile, null));
    this.cdref.markForCheck();
  }

  /**
   * chargement de la pièce jointe
   */
  public loadDropFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.mediaReference);
    
  }


  /* ##############################################################################
          image
  ############################################################################## */

  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup; // image du FDV
    @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  /** présence d'une image, pour affichage de la poubelle */
  public get hasImage(): boolean {
    return !!this.imgSrcObs;
  }

 /**
   * Demande de chargement d'une image
   * sur clic long, ouverture du zoom
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public clickForUpload(latency: number): void {

    // console.log('clickForUpload', latency, this.rawValue); 
    if(!!this.imgSrcObs && latency > 400) {
      this.seeImage();
    } else {
      let params: ImageUploadParameter = {
            component: this.img,
            elementRef: this.img.elementRef,
            dom: this.model.domainCode,
            bu: this.model.businessUnitCode,
            vision: ViewData.wildcardMainVision,
          }
      this.model.batchEngine.loadImage(params);
    }
    // console.log('clickForUpload', e); 
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public keydownForUpload(event: KeyboardEvent): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload(0);
    }
  }

  /**  de suppression des... icones */
  public clearImage(): void {
    this.img.sourceObservable = of(null);
    WizEventManager.dispatchEvent(this.img.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.img, null));
  }

  private zoomPop: WizPopUp; // la popUp de zoom sur les images
  public seeImage(e: Event= null): void {
      let params: zoomPopParams = {
        zoomPop: this.zoomPop,
        blobid: this.imgBlob,
        // arg: this.data.arg,
        //fdvDS: this.data.ds
      }
    
    PopUtils.showZoomPop(params);
  }

}
